import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import ControlledOptionsFieldArray from '../form-helpers/ControlledOptionsFieldArray';
import { Typography } from 'antd';

const { Title } = Typography;

const MobileSelectQuestion = ({isMultiSelect, question, ...restControlledOptionsFieldArrayProps}) => {
  const { t } = useTranslation();
  return (
    <>
      {
        question && (
          <Title level={4} style={styles.question}>
            {t(`${question}`)}
          </Title>
        )
      }
      <Box style={{ padding: 0, marginTop: 24 }}>
        <ControlledOptionsFieldArray isMultiSelect={isMultiSelect} {...restControlledOptionsFieldArrayProps} />
      </Box>
    </>
  );
}

const styles = {
  question: {
    fontWeight: "600", 
    fontSize: "24px", 
    lineHeight: "30px", 
    textAlign: "center", 
    color: "#404047",
    marginBottom: 25,
    marginTop: 50
  }
}

export default MobileSelectQuestion;
